import { z } from 'zod';

/** Wartungsplan (Modul assembly, ADR 0010): wiederkehrende Wartung einer Anlage. */
export const createMaintenanceScheduleSchema = z.object({
  title: z.string().trim().min(1).max(200),
  customerId: z.string().uuid().optional(),
  projectId: z.string().uuid().optional(),
  location: z.string().trim().max(200).optional(),
  intervalMonths: z.number().int().min(1).max(120),
  /** Erste Fälligkeit; ohne Angabe heute + Intervall. */
  nextDueAt: z.string().datetime().optional(),
  notes: z.string().trim().max(5000).optional(),
});
export type CreateMaintenanceScheduleInput = z.infer<typeof createMaintenanceScheduleSchema>;

export const updateMaintenanceScheduleSchema = z
  .object({
    title: z.string().trim().min(1).max(200),
    customerId: z.string().uuid().nullable(),
    projectId: z.string().uuid().nullable(),
    location: z.string().trim().max(200).nullable(),
    intervalMonths: z.number().int().min(1).max(120),
    nextDueAt: z.string().datetime(),
    isActive: z.boolean(),
    notes: z.string().trim().max(5000).nullable(),
  })
  .partial();
export type UpdateMaintenanceScheduleInput = z.infer<typeof updateMaintenanceScheduleSchema>;

/** „Wartung durchgeführt": optionales Durchführungsdatum (Default heute). */
export const completeMaintenanceSchema = z.object({
  performedAt: z.string().datetime().optional(),
});
export type CompleteMaintenanceInput = z.infer<typeof completeMaintenanceSchema>;

export const maintenanceScheduleResponseSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  customerId: z.string().uuid().nullable(),
  customerName: z.string().nullable(),
  projectId: z.string().uuid().nullable(),
  projectCode: z.string().nullable(),
  location: z.string().nullable(),
  intervalMonths: z.number().int(),
  lastServiceAt: z.string().datetime().nullable(),
  nextDueAt: z.string().datetime(),
  isActive: z.boolean(),
  notes: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type MaintenanceScheduleResponse = z.infer<typeof maintenanceScheduleResponseSchema>;
